module.exports = __webpack_public_path__ + "static/media/building_icon.56cffb79.svg";